import { formatRangeDate } from "@/helper/date-time";
import { addQueryParametersToUrl } from "@/helper/query-params/add-query-params-to-url.util";
import { Constants } from "@/services/web/api.const";
import { auth0Config } from "@/configs/auth-config";
import { READ_ORDERS_SCOPE } from "@/modules/finance/helper/constants/api-payment-history.const";
import { useApi } from "@/services/web/use-api";
import { UserProfileDistribution } from "@/types/profile-distribution.type";
import { useMemo } from "react";

export const useUserProfilesDistribution = (cityId: string | undefined | null, startDate: Date, endDate: Date) => {
  const { startDate: start_date, endDate: end_date } = formatRangeDate(startDate, endDate);

  const url = useMemo(() => {
    const params = {
      start_date,
      end_date,
    };

    const url = `${Constants.CLIENTS_API_URL}/payment/orders/${cityId}/user-profiles`;
    return addQueryParametersToUrl(url, params);
  }, [cityId, start_date, end_date]);

  const {
    isLoading: loading,
    error,
    data,
  } = useApi<UserProfileDistribution[]>(
    url,
    {
      method: "GET",
      audience: auth0Config.clientAudiance,
      scope: READ_ORDERS_SCOPE,
    },
    undefined,
    !!cityId,
  );

  return {
    loading,
    error,
    data: data ?? [],
  };
};
